import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationTranslatePost = {
    path: "/translate",
    method: ERouteHttpVerb.POST
};
export { routeLocationTranslatePost };
